import { isSameSearchCriteria } from "domains/publication/reducer";
import { getTmSelectedOuterNode } from "domains/transformationMap/selectors";
import type { RootState } from "types/redux";

export const createPublicationsForTopicSelector = (id: string) => (state: RootState) =>
  state.domains.publication.forTopic[id]?.find((item) =>
    isSameSearchCriteria(item.searchCriteria, {
      ...getPublicationSearchCriteria(state),
      id,
      secondaryTopicId: state.domains.transformationMap.selectedOuterNodeId,
    }),
  );

export const getPublicationSearchCriteria = (state: RootState) => state.domains.publication.searchCriteria;

export const getPublicationSearchTerm = (state: RootState) => getPublicationSearchCriteria(state).search;

export const getIsPublicationFiltered = (state: RootState) => {
  const { language, publication_type, search } = getPublicationSearchCriteria(state);
  return !!language || !!publication_type || !!search || !!getTmSelectedOuterNode(state)?.id;
};

export const getIsPublicationFilterCount = (state: RootState) => {
  const { language, publication_type, search } = getPublicationSearchCriteria(state);
  let count = 0;
  if (language) count++;
  if (publication_type) count++;
  if (search) count++;
  return count;
};
